import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

interface ErrorReportDialogStore {
  show: boolean;
  /** The entity whose error reports should be shown. */
  entityId: string | null;
  open: (entityId: string) => void;
  close: () => void;
}

const useErrorReportDialogStore = create<ErrorReportDialogStore>()(
  devtools(
    (set) => ({
      show: false,
      entityId: null,
      open: (entityId) => {
        set({ show: true, entityId });
      },
      close: () => {
        set({ show: false, entityId: null });
      },
    }),
    {
      name: 'error-report-dialog-store',
      enabled: process.env.NODE_ENV !== 'test',
    },
  ),
);

export default useErrorReportDialogStore;
